import { GraphQlError } from "src/utils/fetcher";

export type RowLookupErrorKind = "forbidden" | "timeout" | "unknown";

// Hasura may drop a remote schema's `extensions`, so each kind also matches the server's message.
const FORBIDDEN_CODE = "FORBIDDEN";
const FORBIDDEN_MESSAGE = "User is not permitted to access resource.";
const TIMEOUT_CODE = "ROW_LOOKUP_TIMEOUT";
const TIMEOUT_MESSAGE = "Row lookup timed out";

const ROW_LOOKUP_ERROR_MESSAGES: Record<RowLookupErrorKind, string> = {
  forbidden:
    "You don't have permission to debug this sync. Ask a workspace admin for access.",
  timeout:
    "This search took longer than 2 minutes and was stopped. Try again, or contact support if it keeps happening.",
  unknown:
    "Something went wrong. Try again, or contact support if it keeps happening.",
};

export function getRowLookupErrorKind(error: unknown): RowLookupErrorKind {
  if (!(error instanceof Error)) return "unknown";
  const code =
    error instanceof GraphQlError ? error.extensions.code : undefined;
  if (code === FORBIDDEN_CODE || error.message === FORBIDDEN_MESSAGE) {
    return "forbidden";
  }
  if (code === TIMEOUT_CODE || error.message === TIMEOUT_MESSAGE) {
    return "timeout";
  }
  return "unknown";
}

export function getRowLookupErrorMessage(error: unknown): string {
  return ROW_LOOKUP_ERROR_MESSAGES[getRowLookupErrorKind(error)];
}
